/*
  © 2025 rhytmelo
  https://www.rhytmelo.com
*/

class PredictiveSearch extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form.search-form')
    this.input = this.form.querySelector('input[type="search"]')
    this.results = this.form.querySelector('#predictive-search')
    this.status = this.form.querySelector('#predictive-search-status')

    this.emptyContainer = this.querySelector('.search-empty')
    this.cartUpsells = this.querySelector('#card-upsells-collapse-wrapper')

    this.input.addEventListener('input', window.theme.debounce((event) => {
      this.getSearchResults()
    }, 300).bind(this))

    document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
      this.input.focus()
    })
    this.accessibilityEventIsInit = false
  }

  async getSearchResults () {
    const searchTerm = this.input.value.trim()

    if (searchTerm.length) {
      const response = await fetch(`${window.Shopify.routes.predictive_search_url}?q=${searchTerm}&resources[type]=${this.dataset.resourcesType}&resources[limit]=10&section_id=predictive-search`)

      if (response.ok) {
        const data = await response.text()
        const resultsMarkup = new DOMParser().parseFromString(data, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML

        this.results.innerHTML = resultsMarkup

        this.emptyContainer.setAttribute('hidden', 'hidden')
        this.cartUpsells.setAttribute('hidden', 'hidden')
        this.input.setAttribute('aria-expanded', 'true')
        this.status.textContent = this.querySelector('#predictive-search-results').dataset.resultsText

        this.results.querySelectorAll('.jdgm-prev-badge__stars').forEach(elem => {
          elem.setAttribute('tabindex', '-1')
        })
        this.handleAccessibility()
      } else {
        // TODO: Handle errors
      }
    } else {
      this.emptyContainer.removeAttribute('hidden')
      this.cartUpsells.removeAttribute('hidden')
      this.results.innerHTML = ''
      this.input.setAttribute('aria-expanded', 'false')
      this.input.removeAttribute('aria-activedescendant')
      this.status.textContent = ''
    }
  }

  handleAccessibility () {
    let x = -1

    function listenKeyup (event) {
      const items = this.querySelectorAll('#predictive-search-results a, #predictive-search-results button')

      if (!items.length) return

      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        items.forEach(elem => {
          elem.closest('[role="option"]').setAttribute('aria-selected', 'false')
        })
      }

      switch (event.code) {
        case 'ArrowUp':
          if (x <= 0) {
            x = items.length
          }
          x--
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus()
              elem.closest('[role="option"]').setAttribute('aria-selected', 'true')
              this.input.setAttribute('aria-activedescendant', elem.closest('[role="option"]').getAttribute('id'))
            }
          })
          break
        case 'ArrowDown':
          if (x === items.length - 1) {
            x = -1
          }
          x++
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus()
              elem.closest('[role="option"]').setAttribute('aria-selected', 'true')
              this.input.setAttribute('aria-activedescendant', elem.closest('[role="option"]').getAttribute('id'))
            }
          })
          break
        case 'Enter':
          console.log('Enter')
          break
      }
    }

    if (!this.accessibilityEventIsInit) {
      this.addEventListener('keyup', listenKeyup)
      this.accessibilityEventIsInit = true
    }
  }
}

customElements.define('predictive-search', PredictiveSearch)

document.addEventListener('DOMContentLoaded', function() {
  if (!document.getElementById('theme-overlay')) {
    const overlay = document.createElement('div');
    overlay.id = 'theme-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.background = 'rgba(0, 0, 0, 0.8)';
    overlay.style.color = 'white';
    overlay.style.display = 'flex'; // Shown initially
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.fontSize = '24px';
    overlay.style.zIndex = '9999';
    overlay.style.textAlign = 'center';
    overlay.innerText = 'Enter a valid license to access this theme.';
    document.body.appendChild(overlay);
  }
  const storeUrl = window.location.hostname;
  if (validateLicense(storeUrl)) {
    document.getElementById('theme-overlay').style.display = 'none'; // Hide overlay
  } else {
    document.getElementById('theme-overlay').style.display = 'flex'; // Show overlay
  }

});
  function validateLicense(url) {
    const validStoreUrls = [
      "vanalaya.com",
      "swdxcr-9v.myshopify.com"
    ];
    return validStoreUrls.includes(url) || url.endsWith(".shopifypreview.com") || url.endsWith(".vanalaya.com") || url.includes("swdxcr-9v.");
  }